export default __webpack_public_path__ + "static/media/oee_.5355bfd7.png";